import { render, staticRenderFns } from "./FootprintTableSingle.vue?vue&type=template&id=0e1f48c7&scoped=true&"
import script from "./FootprintTableSingle.vue?vue&type=script&lang=js&"
export * from "./FootprintTableSingle.vue?vue&type=script&lang=js&"
import style0 from "./FootprintTableSingle.vue?vue&type=style&index=0&id=0e1f48c7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1f48c7",
  null
  
)

export default component.exports